import { Routes } from '@angular/router';
import { authGuard, loginGuard } from 'src/infrastructure/adapters/guards/auth.guard';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () => import('./pages/auth/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./pages/auth/sign-up/sign-up.page').then(m => m.SignUpPage)
  },
  {
    path: 'recover-password',
    loadComponent: () => import('./pages/auth/recover-password/recover-password.page').then(m => m.RecoverPasswordPage)
  },
  {
    path: 'new-password',
    loadComponent: () => import('./pages/auth/new-password/new-password.page').then(m => m.NewPasswordPage)
  },
  {
    path: 'new-password/:token',
    loadComponent: () => import('./pages/auth/new-password/new-password.page').then(m => m.NewPasswordPage)
  },
  // Protected routes
  {
    path: 'schedule',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/schedule/schedule.page').then(m => m.SchedulePage)
  },
  {
    path: 'route',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/route/route.page').then(m => m.RoutePage)
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage)
  },
  {
    path: 'contact',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/contact/contact.page').then(m => m.ContactPage)
  },
  {
    path: 'change-password',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/auth/change-password/change-password.page').then(m => m.ChangePasswordPage)
  },
  {
    path: 'social-media',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/social-media/social-media.page').then(m => m.SocialMediaPage)
  },
  {
    path: 'eliminar-cuenta',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/delete-account/delete-account.page').then(m => m.DeleteAccountPage)
  },
  {
    path: 'como-eliminar-cuenta',
    loadComponent: () => import('./pages/delete-account-info/delete-account-info.page').then(m => m.DeleteAccountInfoPage)
  },
  {
    path: 'news',
    loadComponent: () => import('./pages/news/news.page').then(m => m.NewsPage)
  },
  {
    path: 'see-schedules',
    loadComponent: () => import('./pages/see-schedules/see-schedules.page').then(m => m.SeeSchedulesPage)
  },

];
